export function getSubscriptionAnchorId(subscriptionId) {
    return `sub-${subscriptionId}`;
}
